/**
 * 2026-10-09 — file name for the Voxtral transcript download, derived from the
 * broadcast key so it reads like the program plan:
 * "LIVE/2026/1008 1040/ORFS/broadcast.json" → "voxtral_2026-10-08_1040_ORFS.json".
 * Any other key shape is sanitised so the name never carries slashes or spaces.
 */
export function voxtralExportFileName(broadcastKey: string | null | undefined): string {
  const key = broadcastKey ?? '';
  const m = /^LIVE\/(\d{4})\/(\d{2})(\d{2}) (\d{4})\/([^/]+)\//.exec(key);
  if (m) return `voxtral_${m[1]}-${m[2]}-${m[3]}_${m[4]}_${m[5]}.json`;
  const safe = key.replace(/\.json$/i, '').replace(/[^A-Za-z0-9-]+/g, '_').replace(/^_+|_+$/g, '');
  return `voxtral_${safe || 'export'}.json`;
}
